"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;
exports.getImage = getImage;
exports.ensureUrlHasProtocol = ensureUrlHasProtocol;
exports.encodeUrl = encodeUrl;
exports.isInternal = isInternal;
exports.getImageDimensions = getImageDimensions;
exports.toggleInlineStyleOverride = exports.buildTag = void 0;

var _immutable = require("immutable");

var _hubspot = _interopRequireDefault(require("hubspot.bender"));

var buildTag = function buildTag(tagName, contents) {
  var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var attrStr = '';

  if (Object.keys(attrs).length) {
    attrStr = Object.keys(attrs).filter(function (k) {
      return attrs[k];
    }).map(function (k) {
      return k + "=\"" + attrs[k] + "\"";
    }).join(' ');

    if (attrStr.length) {
      attrStr = " " + attrStr;
    }
  }

  return "<" + tagName + attrStr + ">" + contents + "</" + tagName + ">";
};

exports.buildTag = buildTag;

function memoize(func) {
  var _cache = (0, _immutable.Map)();

  return function () {
    var argList = _immutable.List.of.apply(_immutable.List, arguments);

    if (!_cache.has(argList)) {
      _cache = _cache.set(argList, func.apply(void 0, arguments));
    }

    return _cache.get(argList);
  };
}

function getImage() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _hubspot.default.staticDomainPrefix + "/draft-plugins/static-2.7100/images/" + path;
}

var toggleInlineStyleOverride = function toggleInlineStyleOverride(editorState, styleLookupSet) {
  var currentInlineStyleOverride = editorState.getInlineStyleOverride();

  if (currentInlineStyleOverride === null) {
    currentInlineStyleOverride = editorState.getCurrentInlineStyle();
  }

  return currentInlineStyleOverride.subtract(styleLookupSet);
};

exports.toggleInlineStyleOverride = toggleInlineStyleOverride;

function ensureUrlHasProtocol(url) {
  var trimmed = url.trim();

  if (!url || !trimmed) {
    return url;
  }

  var hasProtocol = trimmed.includes('://') || trimmed.includes('tel:') || trimmed.includes('mailto:');

  if (hasProtocol) {
    return url;
  }

  return "http://" + url;
}

function encodeUrl(url) {
  var anchor = document.createElement('a');
  anchor.href = url;
  anchor.pathname = decodeURIComponent(anchor.pathname);
  return anchor.href;
}

function isInternal() {
  return !window.location.hostname.includes('app.hubspot');
}

function getImageDimensions(blob) {
  var image = new Image();
  image.src = blob;
  return new Promise(function (resolve) {
    image.onload = function () {
      resolve({
        width: this.width,
        height: this.height
      });
    };
  });
}